<template>
    <div>
        <vue-perfect-scrollbar style="height: 408px" :settings="settings">
            <v-data-table :headers="headers" :items="dashboard_quality_control || []" :no-data-text="$t('lang.loading')" hide-actions
                ><template slot="items" slot-scope="props">
                    <tr
                        class="clickable"
                        @click="props.item.qc_id > 0 ? $refs.qc_dialog.showQualityControl(props.item) : $refs.qc_dialog.selectBatch(props.item)"
                    >
                        <td>{{ props.item.batch_id }}</td>
                        <td>{{ props.item.furnace }}</td>
                        <td>{{ props.item.customer_part_number }}</td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.batch_size }}</td>
                        <td>{{ props.item.qc_summary_display }}</td>
                    </tr>
                </template></v-data-table
            >
        </vue-perfect-scrollbar>
        <bc-qc-dialog
            ref="qc_dialog"
            state-property="dashboard_quality_control"
            @scan-error="$refs.scan_barcode.resetBarcode(true)"
            @scan-close="$refs.scan_barcode.closeBarcode()"
            @scan-open="$refs.scan_barcode.openBarcode()"
        ></bc-qc-dialog>
    </div>
</template>
<script>
import api from "Api";
import { mapState, mapActions } from "vuex";
import BcQcDialog from "Modules/manufacturing/quality_control/components/QualityControlDialog";

export default {
    components: {
        BcQcDialog,
    },
    data() {
        return {
            loader: true,
            settings: {
                maxScrollbarLength: 160,
            },
            headers: [
                {
                    text: this.$t("lang.batch_id"),
                    value: "batch_control_id",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.furnace"),
                    value: "furnace",
                    format: (v) => {
                        return v;
                    },
                    align: "center",
                    text_center: true,
                    sortable: false,
                },
                {
                    text: this.$t("lang.part_number_short"),
                    value: "customer_part_number",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.part_name"),
                    value: "name",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.qty"),
                    value: "batch_size",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.status"),
                    value: "qc_summary_display",
                    format: (v) => {
                        return v;
                    },
                    chip_color: "qc_summary_color",
                    align: "center",
                    sortable: false,
                },
            ],
            qc_inspections: [],
        };
    },
    computed: {
        ...mapState({
            dashboard_quality_control: (state) => state.quality_control.dashboard_quality_control,
        }),
    },
    mounted() {
        this.getQualityControl();
    },
    methods: {
        getQualityControl(refresh = false) {
            if (refresh) {
                this.$store.commit("commitQualityControl", {
                    property: "dashboard_quality_control",
                    with: null,
                });
            }

            this.$store
                .dispatch("fetchQualityControl", {
                    url: "quality_control",
                    method: "get",
                    stateProperty: "dashboard_quality_control",
                    dataProperty: "quality_control",
                    commit: true,
                    body: {
                        status: "pending",
                    },
                })
                .then((data) => {
                    this.qc_inspections = data.quality_control;
                });
        },
    },
};
</script>
